module.exports = __webpack_public_path__ + "5a25a6ccb37af7fe25932e711a3b953c.svg";